export const en = {
    "deny-access": "Deny access",
    "error": "An error has occurred.",
    "error-only-private": "Available only for published private skills.",
    "header": "Access",
    "links-button-copy": "Copy",
    "links-button-copy-tooltip": "Copied",
    "links-button-generate": "Generate",
    "links-descr": "Generate a link to grant access to a private skill. After the first use\nthe link will become invalid.",
    "links-header": "One-time links",
    "menu-links": "Links",
    "menu-users": "Users",
    "users-button-reload": "Reload",
    "users-deleted": "The user has been deleted",
    "users-descr": "A list of users who have access to a private skill. Access can be revoked at any time.",
    "users-only-you": "The skill is only available to you.",
    "app-link-description": "Generate a link to provide access to the private application. The link will become invalid after the first use.",
    "app-users-description": "A list of users who have access to the private application. Access can be revoked at any time.",
    "app-available-only-for-you": "The application is available to you only.",
    "max-number-reached": "The maximum number of users who have gained access has been reached."
} as const;
export const ru = {
    "deny-access": "Запретить доступ",
    "error": "Произошла ошибка.",
    "error-only-private": "Доступно только для опубликованных приватных навыков.",
    "header": "Доступ",
    "links-button-copy": "Скопировать",
    "links-button-copy-tooltip": "Скопировано",
    "links-button-generate": "Сгенерировать",
    "links-descr": "Сгенерируйте ссылку, чтобы предоставить доступ к приватному навыку. После первого использования\n                ссылка станет недействительной.",
    "links-header": "Одноразовые ссылки",
    "menu-links": "Ссылки",
    "menu-users": "Пользователи",
    "users-button-reload": "Перезагрузить",
    "users-deleted": "Пользователь удален",
    "users-descr": "Список пользователей, имеющих доступ к приватному навыку. Доступ можно отозвать в любой  момент.",
    "users-only-you": "Навык доступен только вам.",
    "app-link-description": "Сгенерируйте ссылку, чтобы предоставить доступ к приватному приложению. После первого использования ссылка станет недействительной.",
    "app-users-description": "Список пользователей, имеющих доступ к приватному приложению. Доступ можно отозвать в любой момент.",
    "app-available-only-for-you": "Приложение доступно только вам.",
    "max-number-reached": "Достигнуто максимальное количество пользователей, получивших доступ"
} as const;